// TODO: handle gzip encoded data
export async function fetchResponseWithProgress(response, method = 'json', onProgress) {
	const total = +response.headers.get('content-length');
	if (!total || typeof onProgress !== 'function') {
		return response[method]();
	}
	const reader = response.body.getReader();
	const bytes = new Uint8Array(total);
	let received = 0;
	// eslint-disable-next-line no-constant-condition
	while (true) {
		const { done, value } = await reader.read();
		if (done) {
			break;
		}
		bytes.set(value, received);
		received += value.length;
		onProgress({ progress: Math.min(received / total, 1), received, total });
	}
	let result = new TextDecoder('utf-8').decode(bytes);
	if (method === 'json') {
		return JSON.parse(result);
	}
	return result;
}